import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { useTranslation } from '@shared/core';
import { StyledCheckboxV2 } from '@apps/stays/components/filters/StyledCheckboxV2';
import { SkeletonText } from '@shared/components/Skeleton';
import type { Filters } from '@shared/types/Accommodations.types';
import { useListingsPanelTelemetry } from '../ListingsPanel.telemetry';
import { useEventCallback } from '@shared/utils/hooks/useEventCallback';

export const CoupleRecommendationsCheck = ({ handlePickedByCoupleToggle, filters }: { handlePickedByCoupleToggle: () => void; filters: Filters }) => {
  const { t } = useTranslation('accommodationsConsole');
  const listingsTrans = t('listingsPanel');
  const telemetry = useListingsPanelTelemetry();

  const handleToggleWithTelemetry = useEventCallback(() => {
    const newState = !filters.pickedByCouple;
    telemetry.pickedByCoupleToggled({ state: newState });
    handlePickedByCoupleToggle();
  });

  return (
    <Flex
      flexDirection={{ _: 'column', sm: 'row' }}
      rowGap={2}
      justifyContent="space-between"
      alignItems="center"
    >
      <TextV2 typographyVariant={'hed4'}>{listingsTrans.title()}</TextV2>
      <StyledCheckboxV2
        isChecked={filters.pickedByCouple}
        onChange={handleToggleWithTelemetry}
        id={`couple-picks`}
      >
        <TextV2
          typographyVariant="body2"
          color="mono14"
        >
          {listingsTrans.pickedByCouple()}
        </TextV2>
      </StyledCheckboxV2>
    </Flex>
  );
};

CoupleRecommendationsCheck.Skeleton = () => {
  return (
    <Flex
      rowGap={2}
      justifyContent="space-between"
      alignItems="center"
    >
      <SkeletonText
        rows={1}
        width={136}
        skeletonHeight={26}
      />
      <SkeletonText
        rows={1}
        width={290}
        skeletonHeight={26}
      />
    </Flex>
  );
};
